import omit from "lodash/omit";
import { SignupFormSchemaType } from "../../../../components/Auth/Signup/SignupFormSchema";
import { executeNetworkAsync } from "../../../helper/handler/network";
import { clientAxiosInstance } from "../../../types/swrFetcher";

export const authGetOtpController = async (
  email: string,
  action: string,
  recaptchaToken: string,
  country: string,
  signupData?: SignupFormSchemaType
) => {
  const networkCall = async () =>
    await clientAxiosInstance().post("/api/auth/otp/get", {
      email,
      action,
      country,
      recaptchaToken,
      signupData:
        action === "signup"
          ? JSON.stringify(omit(signupData, ["password"]))
          : "",
    });

  const [result, error] = await executeNetworkAsync(networkCall);
  return [result, error];
};
